import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { ConfigProvider, Tabs } from 'antd';
import {
  $profileActiveTab,
  $userInfo,
  changeProfileActiveTabEv,
} from '../../models/authModel/index.js';
import ContainerInner from '../../components/ContentContainer/ContainerInner.jsx';
import PasswordChange from './components/PasswordChange.jsx';
import InvProfile from './components/InvProfile.jsx';
import ProjectProfile from './components/ProjectProfile.jsx';
import CreateProject from '../CreateProject/CreateProject.jsx';
import EditList from '../../components/EditList/EditList.jsx';
import UnpublishedProjects from '../UnpublishedProjects/UnpublishedProjects.jsx';
import OchvTable from '../../components/ProfileComponents/OCHVTable.jsx';
import NppServices from '../../components/ProfileComponents/NPPServices.jsx';
import ProfileRestyle from '../../components/ProfileComponents/ProfileRestyle.jsx';
import MgpContents from '../MGPRegistry/components/MGPContents.jsx';
import UsersLog from '../../components/AdminSecurityTabs/UsersLog.jsx';
import UsersList from '../../components/AdminSecurityTabs/UsersList.jsx';
import UserLoginHistory from '../../components/AdminSecurityTabs/UserLoginHistory.jsx';

const darkTabsTheme = {
  components: {
    Tabs: {
      cardBg: 'black',
      itemColor: 'white',
      itemHoverColor: 'white',
    },
  },
};

export default function Profile() {
  const curUsr = useUnit($userInfo);
  const { t } = useTranslation();

  const isAdmin = useMemo(() => {
    return ['admin', 'superadmin'].includes(curUsr.role);
  }, [curUsr]);

  const changeTab = useUnit(changeProfileActiveTabEv);
  const activeTab = useUnit($profileActiveTab);

  const tabItems = [
    // {
    //   label: t('Актуальное для бизнеса'),
    //   key: 'actual-business',
    //   children: <ProfileRestyle />,
    // },
    {
      label: t('Услуги ЦГО'),
      key: 'cgo-services',
      children: '',
    },
    {
      label: t('Услуги МИО'),
      key: 'mio-services',
      children: '',
    },
    {
      label: t('Финансовые и нефинансовые МП'),
      key: 'fin-non-fin-mp',
      children: <MgpContents />,
    },
    {
      label: t('Услуги НПП'),
      key: 'npp-services',
      children: <NppServices />,
    },
    {
      label: t('Частные услуги'),
      key: 'private-services',
      children: '',
    },
    {
      label: t('Мой профиль'),
      key: 'profile',
      children: (
        <>
          <ProfileRestyle />
          {curUsr.role === 'fundraiser' ||
          curUsr.role === 'potential_investor' ? (
            <InvProfile curUsr={curUsr} />
          ) : (
            <ProjectProfile curUsr={curUsr} />
          )}
        </>
      ),
    },
    {
      label: t('Входящие'),
      key: 'received',
      children: '',
    },
    {
      label: t('Мои документы'),
      key: 'documents',
      children: '',
    },
    {
      label: t('Настройки'),
      key: 'settings',
      children: '',
    },
    {
      label: t('Еще'),
      key: 'more',
      children: '',
    },
    {
      label: t('Создать проект'),
      key: 'create-project',
      children: <CreateProject />,
    },
    {
      label: t('Мои проекты'),
      key: 'edit-project',
      children: <EditList />,
    },
    {
      label: t('Проекты на рассмотрении'),
      key: 'project-requests',
      children: <UnpublishedProjects />,
    },
    {
      label: t('Изменить пароль'),
      key: 'change-password',
      children: <PasswordChange />,
    },
    {
      label: 'Действия пользователей',
      key: 'users-log',
      children: <UsersLog />,
      hidden: !isAdmin,
    },
    {
      label: 'Управление пользователями',
      key: 'users-admin',
      children: <UsersList />,
      hidden: !isAdmin,
    },
    {
      label: 'История авторизации',
      key: 'users-logins',
      children: <UserLoginHistory admin={isAdmin} />,
    },
    // {
    //   label: t('Бесплатные услуги'),
    //   key: 'free-services',
    //   children: <FreeServicesTable />,
    // },
    // {
    //   label: t('Платные услуги'),
    //   key: 'paid-services',
    //   children: <PaidServicesTable />,
    // },
    {
      label: t('Поиск ОЧВ'),
      key: 'search-ochv',
      children: <OchvTable />,
    },
  ];

  const filteredItems = useMemo(() => {
    return tabItems.filter((i) => !i.hidden);
  }, [tabItems]);

  return (
    <ContainerInner>
      <ConfigProvider theme={darkTabsTheme}>
        <Tabs
          destroyInactiveTabPane={true}
          items={filteredItems}
          type="card"
          id="profile-tabs"
          activeKey={activeTab}
          onChange={changeTab}
        />
      </ConfigProvider>
    </ContainerInner>
  );
}
